/**
 * @generated SignedSource<<00475ea77242811e0c5db73d97588a9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type groupsTabRefetchQuery$variables = {
  after?: string | null;
  doCalcMemberCount?: boolean | null;
  filterByName?: string | null;
  first?: number | null;
  includeOwner?: boolean | null;
  includeUser?: boolean | null;
};
export type groupsTabRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"groupsTab_QueryFragment">;
};
export type groupsTabRefetchQuery = {
  response: groupsTabRefetchQuery$data;
  variables: groupsTabRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "doCalcMemberCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByName"
  },
  {
    "defaultValue": 200,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "includeOwner"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "includeUser"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "doCalcMemberCount",
  "variableName": "doCalcMemberCount"
},
v3 = {
  "kind": "Variable",
  "name": "filterByName",
  "variableName": "filterByName"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = {
  "kind": "Variable",
  "name": "includeOwner",
  "variableName": "includeOwner"
},
v6 = {
  "kind": "Variable",
  "name": "includeUser",
  "variableName": "includeUser"
},
v7 = [
  (v1/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "groupsTabRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "groupsTab_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "groupsTabRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountMemberManagementQueries",
        "kind": "LinkedField",
        "name": "AccountMemberManagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "concreteType": "UserInAccountGroupWrappersResult",
            "kind": "LinkedField",
            "name": "UserInAccountGroupWrappers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "UserInAccountGroupWrapperConnection",
                "kind": "LinkedField",
                "name": "userInAccountGroupWrappers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserInAccountGroupWrapperEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInAccountGroupWrapper",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInAccountGroup",
                            "kind": "LinkedField",
                            "name": "group",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isBuiltIn",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "groupsTab_userInAccountGroupWrappers",
                "kind": "LinkedHandle",
                "name": "userInAccountGroupWrappers"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "beb1c2b4df2794860c2e2bccfc0d4e6f",
    "id": null,
    "metadata": {},
    "name": "groupsTabRefetchQuery",
    "operationKind": "query",
    "text": "query groupsTabRefetchQuery(\n  $after: String = null\n  $doCalcMemberCount: Boolean = true\n  $filterByName: String\n  $first: Int = 200\n  $includeOwner: Boolean = true\n  $includeUser: Boolean = true\n) {\n  ...groupsTab_QueryFragment_2kU2dR\n}\n\nfragment editGroupModal_UserInAccountGroupFragment on UserInAccountGroup {\n  id\n  name\n}\n\nfragment groupCard_UserInAccountGroupWrapperFragment on UserInAccountGroupWrapper {\n  id\n  memberCount\n  group {\n    id\n    name\n    isBuiltIn\n  }\n  ...groupContextMenu_UserInAccountGroupWrapperFragment\n}\n\nfragment groupContextMenu_UserInAccountGroupWrapperFragment on UserInAccountGroupWrapper {\n  group {\n    id\n    name\n    isBuiltIn\n    ...editGroupModal_UserInAccountGroupFragment\n  }\n}\n\nfragment groupsTab_QueryFragment_2kU2dR on Query {\n  AccountMemberManagement {\n    UserInAccountGroupWrappers(includeOwner: $includeOwner, includeUser: $includeUser, doCalcMemberCount: $doCalcMemberCount, filterByName: $filterByName) {\n      count\n      userInAccountGroupWrappers(first: $first, after: $after) {\n        edges {\n          node {\n            memberCount\n            group {\n              id\n              name\n              isBuiltIn\n            }\n            ...groupCard_UserInAccountGroupWrapperFragment\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13e44b1f169cf0d0a6aae86d7485e4c4";

export default node;
